import MenuItem from '@material-ui/core/MenuItem'
import { Link } from 'react-router-dom'

const RowActionMenuItem = ({ children, href, onClick, target, to }) => (
  <>
    {to && (
      <MenuItem component={Link} tabIndex={0} to={to}>
        {children}
      </MenuItem>
    )}
    {href && (
      <MenuItem component="a" tabIndex={0} href={href} target={target}>
        {children}
      </MenuItem>
    )}
    {onClick && (
      <MenuItem tabIndex={0} onClick={onClick}>
        {children}
      </MenuItem>
    )}
  </>
)

export default RowActionMenuItem
